module.exports = __webpack_public_path__ + "89f32fb96eb0d8ff7f61ed7ba5f4db3e.png";